import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { Button } from 'antd';

import AgreementModal from './AgreementModal';

import { Check } from '../../../assets/icons';
import { updateUserAgreements } from '../../../services/authApi/userApi';
import { addCounter } from '../../../store/reducer/accountSlice';
import { toastNotify } from '../../../utils/toastNotify';

import useGetUserProfile from '../../../Hooks/useGetUserProfile';

import { POLICY_AGREEMENTS, POLICY_AGREEMENTS_TITLE } from '../../../utils/policy.constants';

const StepFive = (props) => {
  const [isModalOpen, setIsModalOpen] = useState();
  const [activeAgreement, setActiveAgreement] = useState(0);
  const [activeAgreeButton, setActiveAgreeButton] = useState([]);
  const [loading, setLoading] = useState(false);
  const [agreementRead, setAgreementRead] = useState({
    agreement1: false,
    agreement2: false,
    agreement3: false,
    agreement4: false,
    agreement5: false,
  });

  const { userProfileData } = useGetUserProfile();
  const listInnerRef = useRef();
  const dispatch = useDispatch();
  const agreementData = [
    {
      title: POLICY_AGREEMENTS_TITLE.TERMS_OF_USE,
      policyName: POLICY_AGREEMENTS.TERMS_OF_USE,
      isRead: agreementRead.agreement1,
    },
    {
      title: POLICY_AGREEMENTS_TITLE.PRIVACY_POLICY,
      policyName: POLICY_AGREEMENTS.PRIVACY_POLICY,
      isRead: agreementRead.agreement2,
    },
    {
      title: POLICY_AGREEMENTS_TITLE.EFTA,
      policyName: POLICY_AGREEMENTS.EFTA,
      isRead: agreementRead.agreement3,
    },
    {
      title: POLICY_AGREEMENTS_TITLE.DISCLOSURE,
      policyName: POLICY_AGREEMENTS.DISCLOSURE,
      isRead: agreementRead.agreement4,
    },
    {
      title: POLICY_AGREEMENTS_TITLE.SECONDARY_LISTING_AGREEMENT,
      policyName: POLICY_AGREEMENTS.SECONDARY_LISTING_AGREEMENT,
      isRead: agreementRead.agreement5,
    },
  ];

  const allAgreementsRead = agreementData.every((data) => data.isRead);

  useEffect(() => {
    if (userProfileData?.verifiedAgreementDocs && Object.keys(userProfileData?.verifiedAgreementDocs).length === 5) {
      setAgreementRead({ ...userProfileData?.verifiedAgreementDocs });
    }
  }, [userProfileData?.verifiedAgreementDocs]);

  const showModal = (value) => {
    setActiveAgreement(value);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleNext = () => {
    //check if all agreement is read then close modal
    if (agreementData.length === activeAgreement + 1 || agreementRead[activeAgreement + 1]) {
      closeModal();
    } else {
      setActiveAgreement((prevValue) => prevValue + 1);
      agreementData[activeAgreement].isRead = true;
    }

    setAgreementRead((prevState) => ({
      ...prevState,
      [`agreement${activeAgreement + 1}`]: true,
    }));

    // if all are checked then close the model
    if (allAgreementsRead) {
      closeModal();
    }
  };

  const handleAgreeAndContinue = async () => {
    if (!agreementRead[`agreement${activeAgreement + 1}`]) {
      setLoading(true);
      const agreementBodyData = {
        agreementName: `agreement${activeAgreement + 1}`,
      };
      try {
        const resp = await updateUserAgreements(agreementBodyData);
        if (!resp.isError) {
          //handle next agreement open

          handleNext();

          setTimeout(() => {
            activeAgreement + 1 !== agreementData.length && listInnerRef.current.scrollIntoView({ behavior: 'smooth' });
          }, 500);
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      handleNext();
    }
  };
  const handleClickDone = () => {
    if (allAgreementsRead) {
      dispatch(addCounter(5));
      props.nextAction('StepSix');
    }
  };
  const handleClickReview = () => {
    const findAgreementIndex = agreementData.findIndex((data) => !data.isRead);
    if (findAgreementIndex !== -1) {
      setActiveAgreement(findAgreementIndex);
      setIsModalOpen(true);
    }
  };

  const handleScrolltoBottom = (isVisible) => {
    if (isVisible && !activeAgreeButton.includes(activeAgreement)) {
      setActiveAgreeButton((prevState) => [...prevState, activeAgreement]);
    }
  };

  const onDoneClick = () => {
    if (allAgreementsRead) {
      handleClickDone();
    } else {
      handleClickReview();
    }
  };

  return (
    <div className='auth-form stepfive agreement'>
      <div className='agreement__list'>
        {agreementData.map((agreementItem, index) => (
          <div className='agreement__item' key={agreementItem.policyName}>
            <p className='agreement__item__name' onClick={() => showModal(index)}>
              {agreementItem.title}
            </p>
            <Check verticalAlign='middle' className={classNames({ 'check-green': agreementItem.isRead, 'check-taupe': !agreementItem.isRead })} />
          </div>
        ))}
      </div>
      <div className='auth-form__fixed-submit'>
        <Button type='primary' className='ant-btn-primary--alt' onClick={onDoneClick}>
          {allAgreementsRead ? 'Done' : 'Review'}
        </Button>
      </div>
      {isModalOpen && (
        <AgreementModal
          activeAgreeButton={activeAgreeButton}
          activeAgreement={activeAgreement}
          agreementData={agreementData}
          closeModal={closeModal}
          title={agreementData[activeAgreement].title}
          policyName={agreementData[activeAgreement].policyName}
          handleAgreeAndContinue={handleAgreeAndContinue}
          handleScrolltoBottom={handleScrolltoBottom}
          isModalOpen={isModalOpen}
          listInnerRef={listInnerRef}
          loading={loading}
          key={activeAgreement}
        />
      )}
    </div>
  );
};

StepFive.propTypes = {
  nextAction: PropTypes.func,
};

export default StepFive;
